'use strict';

import $ from 'jquery';
import mediator from '../../js/mediator';
import config from '../../js/config';
import breakpoints from '../../js/breakpoints';
import Analytics from '../Analytics/Analytics';
import pdpMobileTabsTemplate from './PdpMobileTabs.hbs';

const TAB_HIDDEN_CLASS = 'PdpMobileTabs-panel--hidden';

class PdpMobileTabs {
  /**
   * Construct the PDP mobile tabs.
   *
   * @param {HTMLElement} el - The DOM node for the tab container.
   */
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.initialize();
  }

  initialize() {
    this.$panels = $('.PdpMobileTabs-panel').sort((a, b) => a.dataset.pdpMobileTabOrder - b.dataset.pdpMobileTabOrder);
    this.render();
    this.updateSelectedStates(0);

    this.$el.on('click', 'li', this.onSelectTab.bind(this));
    mediator.on(config.events.scrollTo, this.activatePanelOnScrollTo, this);
  }

  /**
   * Render the tabs.
   */
  render() {
    let tabs = this.$panels.map((n, el) => {
      return {
        title: el.dataset.pdpMobileTabTitle,
        color: el.dataset.pdpMobileTabColor
      }
    }).get();

    this.$el.html(pdpMobileTabsTemplate({ tabs }));

    this.$tabs = this.$el.find('li');
  }

  /**
   * When a tab has been clicked on.
   *
   * @param {Event} e - The jquery click event.
   */
  onSelectTab(e) {
    let $tab = $(e.currentTarget);
    if ($tab.hasClass(config.classes.isActive)) {
      return;
    }

    let tabIndex = $tab.data('index');

    Analytics.pushToEventFramework({
      event: config.analytics.events.click,
      category: config.analytics.categories.productDetail,
      action: config.analytics.actions.click,
      label: `ProductInfoTab${config.analytics.attributes.utility.separator}${tabIndex}`
    });

    this.updateSelectedStates(tabIndex);
  }

  /**
   * Activate a panel if it was the one the ScrollTo component is attempting to scroll to.
   *
   * @listens config.events.scrollTo
   * @param {Object} options
   * @param {string|HTMLElement} options.selector - The selector to scroll to.
   */
  activatePanelOnScrollTo(options) {
    // Only care about mobile & tablet
    if (breakpoints.isGreaterThan(config.breakpoint.desktop, true)) {
      return;
    }

    let $target = $(options.selector);
    let isPanel = $target.hasClass('PdpMobileTabs-panel');

    // See if we are nested in a panel
    if (!isPanel) {
      $target = $target.parents('.PdpMobileTabs-panel');
      isPanel = $target.hasClass('PdpMobileTabs-panel');
    }

    // Only interested if we are scrolling to a panel and it is not active
    if (!isPanel || !$target.hasClass(TAB_HIDDEN_CLASS)) {
      return;
    }

    // Activate the tab
    this.updateSelectedStates(this.$panels.index($target));
  }

  /**
   * Update the selected states of the tabs based on this.activeTabIndex.
   *
   * @param {number} [index = 0] - The tab index to show.
   */
  updateSelectedStates(index = 0) {
    // Change panel visibility
    this.$panels.removeClass(TAB_HIDDEN_CLASS);
    this.$panels.not(`:eq(${index})`).addClass(TAB_HIDDEN_CLASS);

    // Change active tab indicator
    this.$tabs.removeClass(config.classes.isActive);
    this.$tabs.eq(index).addClass(config.classes.isActive);

    // Trigger page resize
    mediator.trigger(config.events.ui.resize);
    mediator.trigger(config.events.ui.resizeThrottle);
  }
}

export function createPdpMobileTabs($parent) {
  let $pdpMobileTabs = $parent.find('.PdpMobileTabs');
  if ($pdpMobileTabs.length) {
    new PdpMobileTabs($pdpMobileTabs.get(0));
  }
}



// WEBPACK FOOTER //
// ./assets/components/PdpMobileTabs/PdpMobileTabs.js